import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import StyledLink from '../StyledLink';

const HeaderComponent = ({ id, name }) => {
  const { t } = useTransl();

  return (
    <Box mb={1}>
      <Typography variant="h5">
        {/* TODO - review the 'name' value when the 'save changes' modal is opened */}
        {t('title.settingsFor')}{' '}
        <StyledLink to={`/building/${id}`}>{name}</StyledLink>
      </Typography>
    </Box>
  );
};

HeaderComponent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
};

export default HeaderComponent;
